import { FlowbiteUsersGroupSolid } from '../../../../../../assets/icon/iconify'
import Label from '../../../../../ui/label'

interface Props {
    title: string,
    fontSize: string,
    fontWeight: string,
}

export default function HeaderRates({ title, fontSize, fontWeight }: Props) {
    return (
        <div className='flex space-x-2 items-center px-1 py-1'>
            <div>
                <FlowbiteUsersGroupSolid color={`#186cb2`} width={20} height={20} />
            </div>
            <Label
                label={title}
                fontSize={fontSize}
                fontWeight={fontWeight}
            />
        </div>
    )
}
